import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';

function ProductGroup({
	title = 'Choose your color:',
	selectedOption = [],
	allSelectedOptions = [],
	options = ['white', 'purple', 'pink', 'blue', 'orange'],
	isColor = false,
	product = {},
	standAlone = false,
	groupsMap = {},
	level = 0,
}: {
	options?: any[];
	isColor?: boolean;
	title?: string;
	selectedOption: any;
	product: any;
	standAlone: boolean;
	allSelectedOptions: any[];
	groupsMap: any;
	level?: number;
}) {
	const groupId = useMemo(() => {
		const optionsIds = options.map((e) => e.id);
		for (let i in allSelectedOptions) {
			const option = allSelectedOptions[i];
			if (optionsIds.includes(option)) {
				return parseInt(i);
			}
		}
		return 0;
	}, [allSelectedOptions, options]);

	const selectedOptionIndex = useMemo(() => {
		const optionsIds = groupsMap.options.map((e: any) => e.id);
		const reversed = optionsIds;
		for (let i in reversed) {
			const option = reversed[i];
			if (allSelectedOptions.includes(option)) {
				return parseInt(i);
			}
		}
		return 0;
	}, [allSelectedOptions, groupsMap]);

	return (
		<div>
			<div>
				<p className="text-[16px] font-medium">
					{title}
					{title.includes(':') ? '' : ':'}
				</p>
			</div>
			<div className="flex flex-row gap-[30px] mt-[14px]">
				{options.map((option, index) => (
					<OptionButton key={option.id} groupsMap={groupsMap} option={option} selected={selectedOption?.includes(option.id)} product={product} isColor={isColor} allSelectedOptions={allSelectedOptions} groupIndex={groupId} level={level} />
				))}
			</div>
			{!!groupsMap.options[selectedOptionIndex]?.subGroup && (
				<div className="mt-[20px]">
					<ProductGroup
						product={product}
						options={groupsMap.options[selectedOptionIndex].subGroup.options}
						groupsMap={groupsMap.options[selectedOptionIndex].subGroup}
						selectedOption={selectedOption}
						allSelectedOptions={allSelectedOptions}
						isColor={!!groupsMap?.options[selectedOptionIndex]?.subGroup?.options[0]?.color}
						title={groupsMap.options[selectedOptionIndex].subGroup.name}
						standAlone={false}
						level={1}
					/>
				</div>
			)}
		</div>
	);
}

const OptionButton = ({ option, selected = false, isColor = false, product = {}, allSelectedOptions = [], groupIndex, groupsMap, level }: { option: any; selected: boolean; isColor: boolean; product: any; allSelectedOptions: any[]; groupIndex: number; groupsMap: any; level: number }) => {
	const { selectedOptions } = useMemo(() => {

		if (allSelectedOptions.length === 1) return {selectedOptions : option.id};
		let firstGroupOption = 0;
		let secondGroupOption = 0;

		if (level === 0) {
			firstGroupOption = option.id;
			secondGroupOption = allSelectedOptions[1];
		} else {
			firstGroupOption = allSelectedOptions[0];
			secondGroupOption = option.id;
		}

		const firstGroupOptionIndex = groupsMap?.options?.findIndex((e: any) => e.id === firstGroupOption);
		const secondGroupOptionIndex = groupsMap?.options[firstGroupOptionIndex]?.subGroup?.options?.findIndex((e: any) => e.id === secondGroupOption) ?? groupsMap?.options?.findIndex((e: any) => e.id === secondGroupOption);

		if (secondGroupOptionIndex === -1 || !secondGroupOptionIndex) {
			secondGroupOption = groupsMap?.options[firstGroupOptionIndex]?.subGroup?.options[0]?.id ?? groupsMap?.options[0]?.id;
		}

		return { selectedOptions: `${secondGroupOption},${firstGroupOption}` };
	}, [allSelectedOptions, groupsMap, option]);

	return (
		<Link to={`/product/${product.urlSlug}--${selectedOptions}?standalone=false`} aria-disabled={selected}>
			<div className="flex flex-col items-center cursor-pointer">
				<div className={`min-w-[40px] h-[40px] flex items-center justify-center rounded-full px-[5px] ${selected ? 'border border-[#F89DBD]' : ''}`}>
					{!isColor && <div className="font-normal text-[14px] capitalize">{option.name}</div>}
					{isColor && <div style={{ backgroundColor: !!option?.color ? option?.color : '#C52A2A' }} className="border border-[#F1F1FE] rounded-full h-[30px] w-[30px]"></div>}
				</div>
				{isColor && <div className="mt-[8px] text-[14px] font-normal capitalize">{option.name}</div>}
			</div>
		</Link>
	);
};

export default ProductGroup;
